var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "widthFull center pt-1 pb-1" },
    [
      _vm.loadingState ? _c("loading") : _vm._e(),
      _vm._v(" "),
      _c(
        "form",
        {
          staticClass: " black pl-4 pr-4 mb-3 widthFull vaillantCont",
          on: {
            submit: function($event) {
              $event.preventDefault()
              return _vm.editUser()
            }
          }
        },
        [
          _c("div", { staticClass: "row justify-content-center " }, [
            _c("div", { staticClass: "col-md-12 vaillantCont  text-left" }, [
              _c("div", { staticClass: "group mt-1" }, [
                _vm._m(0),
                _vm._v(" "),
                _vm.getProfile.tipo_azienda != "Ditta Individuale" &&
                _vm.getProfile.tipo_azienda != "Professionista iscritto ad albi"
                  ? _c(
                      "div",
                      { staticClass: "form-check form-check-inline mt-2" },
                      [
                        _c(
                          "label",
                          {
                            staticClass: "form-check-label ",
                            on: {
                              click: function($event) {
                                _vm.delegate_move_credits = 1
                              }
                            }
                          },
                          [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.delegate_move_credits,
                                  expression: "delegate_move_credits"
                                },
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: "required|included:1,2",
                                  expression: "'required|included:1,2'"
                                }
                              ],
                              staticClass: "form-check-input inline mr-3",
                              class: {
                                "is-invalid": _vm.errors.has(
                                  "delegate_move_credits"
                                )
                              },
                              attrs: {
                                type: "radio",
                                value: "1",
                                name: "delegate_move_credits"
                              },
                              domProps: {
                                checked: _vm._q(_vm.delegate_move_credits, "1")
                              },
                              on: {
                                change: function($event) {
                                  _vm.delegate_move_credits = "1"
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c("b", [
                              _vm._v(
                                "AUTORIZZO la delega all'intermediario abilitato"
                              )
                            ])
                          ]
                        )
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "form-check form-check-inline" }, [
                  _c(
                    "label",
                    {
                      staticClass: "form-check-label Bold pt-3",
                      on: {
                        click: function($event) {
                          _vm.delegate_move_credits = 2
                        }
                      }
                    },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.delegate_move_credits,
                            expression: "delegate_move_credits"
                          }
                        ],
                        staticClass: "form-check-input inline mr-3",
                        class: {
                          "is-invalid": _vm.errors.has("delegate_move_credits")
                        },
                        attrs: {
                          type: "radio",
                          value: "2",
                          name: "delegate_move_credits"
                        },
                        domProps: {
                          checked: _vm._q(_vm.delegate_move_credits, "2")
                        },
                        on: {
                          change: function($event) {
                            _vm.delegate_move_credits = "2"
                          }
                        }
                      }),
                      _vm._v(
                        "\n              NON AUTORIZZO la delega all'intermediario abilitato (*)\n              "
                      )
                    ]
                  )
                ]),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.errors.has("privacy4"),
                        expression: "errors.has('privacy4')"
                      }
                    ],
                    staticClass: "errorMes Bold"
                  },
                  [
                    _vm._v(
                      "\n            Il consenso deve essere accettato oppure rifiutato\n          "
                    )
                  ]
                )
              ]),
              _vm._v(" "),
              _vm.delegate_move_credits == 1
                ? _c("h5", { staticClass: "pl-md-5 pb-1 " }, [
                    _vm._v(
                      "\n            Si richiede di accedere alla Piattaforma di Gestione Crediti Agenzia delle Entrate "
                    ),
                    _vm._m(1),
                    _vm._v(
                      "\n            della Società per l’inserimento del Codice Fiscale e del Nome dell'intermediario abilitato per la delega:\n\n            "
                    ),
                    _c(
                      "h5",
                      { staticClass: "h5 pt-1 Bold " },
                      [
                        _vm._v(
                          "\n              Inserire il seguente Codice Fiscale e Nome dell'intermediario abilitato"
                        ),
                        _c("br"),
                        _vm._v(" "),
                        _vm.brand != "CHEBONUS"
                          ? [
                              _c("b", [
                                _vm._v(" SLMFMR80D25F205P – Fabio Salamina")
                              ])
                            ]
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.brand == "CHEBONUS"
                          ? [
                              _c("b", [
                                _vm._v(
                                  " DLFMSM72D02H501O – Massimiliano Delfini"
                                )
                              ])
                            ]
                          : _vm._e()
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c("h5", { staticClass: " mb-5 pb-md-5 borderBottom" }, [
                      _vm.brand != "CHEBONUS"
                        ? _c(
                            "a",
                            {
                              staticClass: "black underline",
                              attrs: {
                                href:
                                  "https://storage.googleapis.com/happybonus/Nomina_incarica_o_KPMG_Salamina_Fabio.pdf",
                                target: "_blank"
                              }
                            },
                            [_c("b", [_vm._v(" Qui ")])]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.brand == "CHEBONUS"
                        ? _c(
                            "a",
                            {
                              staticClass: "black underline",
                              attrs: {
                                href:
                                  "https://storage.googleapis.com/chebonus/Nomina_incaricato_KPMG_Delfini_Massimiliano.pdf",
                                target: "_blank"
                              }
                            },
                            [_c("b", [_vm._v(" Qui ")])]
                          )
                        : _vm._e(),
                      _vm._v(
                        "\n               è possibile scaricare il manuale operativo per la nomina dell'intermediario abilitato.\n            "
                      )
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm._m(2),
              _vm._v(" "),
              _c("p", { staticClass: "pb-4 pb-1" }, [
                _vm._v(
                  "\n          Gli aderenti con forma giuridica Ditte Individuali o Professionisti iscritti all'albo dovranno provvedere autonomamente alla gestione dei crediti nel proprio cassetto fiscale.\n        "
                )
              ])
            ]),
            _vm._v(" "),
            _vm.getProfile.delegate_move_credits != _vm.delegate_move_credits
              ? _c("div", { staticClass: "col-md-12 center mb-3 pt-0  mb-1" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-sm btn-primary",
                      attrs: { type: "submit" }
                    },
                    [_vm._v("\n          Salva\n        ")]
                  )
                ])
              : _vm._e()
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "label",
      {
        staticClass: "form-check-label widthFull Bold blue h5",
        attrs: { for: "delegate_move_credits" }
      },
      [
        _c("b", [
          _vm._v(
            "Delega intermediario abilitato ad operare nel cassetto fiscale dell'aderente"
          )
        ]),
        _vm._v(" "),
        _c("br"),
        _vm._v(" "),
        _c("small", [
          _vm._v(
            "\n              ( con la presente delega autorizzi l'intermediario abilitato ad operare nel tuo cassetto fiscale per accettare il credito dal tuo cliente e cedere il relativo credito al cessionario finale )"
          )
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("b", [
      _c(
        "a",
        {
          staticClass: "black underline",
          attrs: {
            href: "https://www.agenziaentrate.gov.it/portale/area-riservata",
            target: "_blank"
          }
        },
        [_vm._v(" Fisconline / Entratel")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "pl-md-5 pb-1" }, [
      _c("b", [
        _vm._v(
          "(*) Se \"NON AUTORIZZO\", l'operatività all'interno del cassetto fiscale rimarrà a tuo carico o del consulente fiscale/commercialista da te delegato. "
        )
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-10101776", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-10101776","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/flowSettings/delegaForm.vue
// module id = null
// module chunks = 